import Button from '@sats-group/ui-lib/react/button';
import Checkbox from '@sats-group/ui-lib/react/checkbox';
import Modal from '@sats-group/ui-lib/react/modal';
import React from 'react';
import type { CheckboxCard as Props } from './checkbox-card.types';

/**
 * Children will be rendered as the modal's (`info.modal`) content.
 *
 * Design: https://www.figma.com/design/CemEcLe6DpoD5ELrFqlwZ7/shared-web-components?node-id=13684-23747
 */
const CheckboxCard: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  info,
  input,
  inputOverrides,
}) => (
  <div className="checkbox-card">
    <div>
      <Checkbox {...input} {...inputOverrides} />
    </div>
    <div>
      <Button
        popoverTarget={info.modal.id}
        size={Button.sizes.small}
        text={info.trigger}
        variant={Button.variants.tertiary}
      />
    </div>
    <Modal {...info.modal}>{children}</Modal>
  </div>
);

export default CheckboxCard;
